module.exports = __webpack_public_path__ + "img/course-bigcover04.0e24bf93.png";